import type { FC, ReactNode } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Footer from '@components/Footer/Footer';
import { SVGSprite } from '@reverse-hr/design-system';

interface TErrorScreenProps {
  children?: ReactNode;
  className?: string;
  title?: string;
}

export const ErrorScreen: FC<TErrorScreenProps> = ({
  children,
  className,
  title,
}) => {
  const { t } = useTranslation('', {
    keyPrefix: 'general.error',
  });

  const wrapperClassNames = classNames('c-error-screen', className);
  const screenTitle = title ?? t('title');

  const headerLogo = __ENVIRONMENT_CONFIG__.IS_THEME_AKI
    ? `${__ENVIRONMENT_CONFIG__.PUBLIC_URL}/assets/images/logo/aaron-king-logo.png`
    : `${__ENVIRONMENT_CONFIG__.PUBLIC_URL}/assets/images/logo/reverse-logo.svg`;

  const footerLogo = __ENVIRONMENT_CONFIG__.IS_THEME_AKI
    ? `${__ENVIRONMENT_CONFIG__.PUBLIC_URL}/assets/images/logo/aaron-king-logo.png`
    : '';

  const footerPayoff = __ENVIRONMENT_CONFIG__.IS_THEME_AKI
    ? 'aki-payoff'
    : 'reverse-payoff';

  return (
    <main className={wrapperClassNames}>
      <header className="c-error-screen__header">
        <img
          alt="Logo Reverse"
          className="c-error-screen__logo"
          src={headerLogo}
        />
      </header>

      <div className="c-error-screen__wrapper">
        <h1 className="c-error-screen__title">{screenTitle}</h1>
        <div className="c-error-screen__content">{children}</div>
      </div>

      <Footer logo={footerLogo} payoff={footerPayoff} />
      <SVGSprite />
    </main>
  );
};
